// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-task-v2-description a {
  color: var(--branded-color);
}
.fi-task-v2-description .fi-attachments-list.has-attachments.new-layout {
  margin-top: 0;
  gap: 16px;
}
.fi-task-v2-description .fi-attachments-list.has-attachments.new-layout .fi-attachments-list-item {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./Source/app/task-v2/fi-task-v2-details/task-v2-description/task-v2-description.component.scss"],"names":[],"mappings":"AACI;EACI,2BAAA;AAAR;AAEI;EACI,aAAA;EACA,SAAA;AAAR;AACQ;EACI,SAAA;AACZ","sourcesContent":[".fi-task-v2-description {\r\n    a {\r\n        color: var(--branded-color);\r\n    }\r\n    .fi-attachments-list.has-attachments.new-layout {\r\n        margin-top: 0;\r\n        gap: 16px;\r\n        .fi-attachments-list-item {\r\n            margin: 0;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
